module.exports = __webpack_public_path__ + "static/media/we.5ca11e50.png";